import { NavigateFunction } from 'react-router-dom';

import { ChecklistItemDefinition } from '../../api/checklistItemDefinitions';

import { ChecklistItemIdentifier } from './identifiers';

export const getOnAfterCompletedClickHandler = ({
  item,
  navigate,
  ceremonyId,
  setChooseCollaboratorModalOpen,
}: {
  item: ChecklistItemDefinition;
  navigate: NavigateFunction;
  ceremonyId: number | null | undefined;
   setChooseCollaboratorModalOpen: (value: boolean) => void,
}) => {
  switch (item.identifier) {
    case ChecklistItemIdentifier.ORDAINED:
      return () => {
        if (
          item.member_checklist_item &&
          item.member_checklist_item.completed
        ) {
          if (ceremonyId) {
            navigate(`/ceremony/${ceremonyId}/ordained`);
          }
        }
      };
    case ChecklistItemIdentifier.PHYSICAL_DOCS:
      return () => {
        window.dispatchEvent(new CustomEvent('pco:openInfoModal'));
      };
    case ChecklistItemIdentifier.COLLABORATION_BUNDLE:
      return () => setChooseCollaboratorModalOpen(true);
    default:
      return;
  }
};
